// const host = location.origin;

export const development = {
  // VUE_APP_API_HOST_ZLZ: 'https://test.fyworkshop.com:8443/gisnanhai' // 测试服
  VUE_APP_API_HOST_ZLZ: 'https://xiaoshan.scanarchi.com/xiaoshangis' // LI HOST
  // VUE_APP_API_HOST_ZLZ: `${host}:9409/nanhaigis` // 正式服 HOST
  // VUE_APP_API_HOST_ZLZ: 'https://test.fyworkshop.com:8443/nanhaigis' // 测试服
};
